import i18n from "@/plugins/i18n";

export default {
  decoders: [
    { name: i18n.t("tag.chooseDecoder"), value: "" },
    { name: "Adeunis Temp", value: "adeunis_temp" },
    { name: "Adeunis 4DI", value: "adeunis_4di" },
    { name: "Adeunis 50A", value: "adeunis50a" },
    { name: "Adeunis 100A", value: "adeunis100a" },
    { name: "Aqualabo", value: "aqualabo" },
    { name: "Ellenex", value: "ellenex" },
    { name: "Elsys", value: "elsys" },
    { name: "Hummbox", value: "hummbox" },
    { name: "Tecscale", value: "tecscale" },
    { name: "Yabby Gps", value: "yabby_gps" },
    { name: "Guppy Gps", value: "guppy_gps" },
    { name: "Oyster Gps", value: "oyster_gps" },
    { name: "Ursalink N1", value: "ursalink_n1" },
    { name: "Ursalink T1", value: "ursalink_t1" },
    { name: "Radiobrige DI", value: "radiobridge_di" },
    { name: "SigFox Tempguard", value: "sigfox_tempguard" },
    { name: "Sensative Strips", value: "strips" },
    { name: "Axiom Water Gauge", value: "axiom_water_guage" },
    { name: "Epic Sensor", value: "epicwlt" },
    { name: "Ecoadapt", value: "ecoadapt" },
    { name: "Squid Decoder", value: "squid" },
    { name: "IMBuildings People Counter", value: "people_counter" },
    { name: "EnLink", value: "enlink" },
    { name: "Ursalink AM100", value: "ursalink_am100" },
    { name: "Ursalink EM500", value: "ursalink_em500" },
    { name: "Digital Matter Sensordata", value: "dm_sensordata" },
    { name: "MCF88", value: "mcf88" },
    { name: "ELA Innovation", value: "ela_innovation" },
    { name: "Polysense", value: "polysense" },
    { name: "Robeau DN20", value: "robeau_dn20" },
    { name: "Robeau DN25", value: "robeau_dn25" },
    { name: "Pycom Scale", value: "pycomscale" },
    {
      name: "MCF88 RS485 Thermoelement",
      value: "mcf88_rs485_thermoelement",
    },
    { name: "Raw Data", value: "raw" },
    { name: "Netvox 150", value: "netvox_150" },
    { name: "Tektelic Agri", value: "tektelic_agri" },
    { name: "Talkpool OY1210", value: "talkpool_oy1210" },
    { name: "IoT-AB Pycom", value: "iot_pycom" },
    { name: "Keller ADT1", value: "keller_adt1" },
    { name: "Snow Depth Lidar", value: "snow_depth" },
    { name: "Laird RS1XX", value: "laird_rs1xx" },
    { name: "Browan TBMS100", value: "browan_tbms100" },
    { name: "Infinite Informatics ADS270", value: "infinite_ads270" },
    { name: "ParametricPCR2", value: "parametric_pcr2" },
    { name: "Adeunis Field Tester", value: "adeunis_ftd" },
    { name: "ICT International EF NODE", value: "ict_ef_node" },
    { name: "Decentlab Depth Temp", value: "dl_depth" },
    { name: "Decentlab Range Finder", value: "decentlab_range_finder" },
    { name: "Decentlab Pressure Temp", value: "decentlab_pressure_temp" },
    { name: "Decentlab 10HS", value: "decentlab_10hs" },
    { name: "Decentlab 5TE", value: "decentlab_5te" },
    { name: "Decentlab 5TM", value: "decentlab_5tm" },
    { name: "Decentlab AC", value: "decentlab_ac" },
    { name: "Decentlab ATM22", value: "decentlab_atm22" },
    { name: "Decentlab ATM41", value: "decentlab_atm41" },
    { name: "Decentlab CTD10", value: "decentlab_ctd10" },
    { name: "Decentlab DLR2002", value: "decentlab_dlr2002" },
    { name: "Decentlab DLR2003", value: "decentlab_dlr2003" },
    { name: "Decentlab DLR2004", value: "decentlab_dlr2004" },
    { name: "Decentlab DLR2005", value: "decentlab_dlr2005" },
    { name: "Decentlab DLR2006", value: "decentlab_dlr2006" },
    { name: "Decentlab DLR2008", value: "decentlab_dlr2008" },
    { name: "Decentlab DLR20010", value: "decentlab_dlr20010" },
    { name: "Decentlab DLR20012", value: "decentlab_dlr20012" },
    { name: "Decentlab DS18", value: "decentlab_ds18" },
    { name: "Decentlab GS3", value: "decentlab_gs3" },
    { name: "Decentlab IAM", value: "decentlab_iam" },
    { name: "Decentlab ITST", value: "decentlab_itst" },
    { name: "Decentlab KL66", value: "decentlab_kl66" },
    { name: "Decentlab LP8P", value: "decentlab_lp8p" },
    { name: "Decentlab MBX", value: "decentlab_mbx" },
    { name: "Decentlab OPTOD", value: "decentlab_optod" },
    { name: "Decentlab PAR", value: "decentlab_par" },
    { name: "Decentlab PR21", value: "decentlab_pr21" },
    { name: "Decentlab PR26", value: "decentlab_pr26" },
    { name: "Decentlab PR36", value: "decentlab_pr36" },
    { name: "Decentlab PR36CTD", value: "decentlab_pr36ctd" },
    { name: "Decentlab PYR", value: "decentlab_pyr" },
    { name: "Decentlab RHC", value: "decentlab_rhc" },
    { name: "Decentlab SHT21", value: "decentlab_sht21" },
    { name: "Decentlab SHT35", value: "decentlab_sht35" },
    { name: "Decentlab SMTP", value: "decentlab_smtp" },
    { name: "Decentlab TBRG", value: "decentlab_tbrg" },
    { name: "Decentlab TRS11", value: "decentlab_trs11" },
    { name: "Decentlab TRS12", value: "decentlab_trs12" },
    { name: "Decentlab TRS21", value: "decentlab_trs21" },
    { name: "Decentlab ZN1", value: "decentlab_zn1" },
    { name: "Decentlab ZN2", value: "decentlab_zn2" },
  ],
};
